module.exports = {
  "country": "MT",
  "artist": "Chiara",
  "song": "That One That I Love",
  "year": "1998",
  "place": "3",
  "spotify": "3s1GSTcK3WAVbQhpVVziKN"
};